module.exports = __webpack_public_path__ + "img/62ac5d0a00124f689861971dc1048e73.bb90f0d1.jpg";